import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", {
      class: "botao habilitado",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editar && _ctx.editar(...args)), ["prevent"]))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-edit" })
    ]),
    _createElementVNode("span", {
      class: "botao habilitado",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)), ["prevent"]))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-trash" })
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.classesDescer),
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.descer && _ctx.descer(...args)), ["prevent"]))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-arrow-up" })
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.classesSubir),
      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.subir && _ctx.subir(...args)), ["prevent"]))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-arrow-down" })
    ], 2)
  ]))
}